// const base = 'http://localhost:9001';

const base = 'https://api.hemacabs.com';
const sub_url = "/api/v1/";

// const client_url = 'http://127.0.0.1:8000'
const client_url = 'http://31.97.206.32:9097/'


export const ENDPOINT = {
    client_url: client_url,
    base: base,
    sub_url: sub_url,
    get_car_data_by_distance: `${base}${sub_url}product/cars/distance`,
    get_car_data: `${base}${sub_url}product/cars`,

    car_distance: `product/cars/distance/`,
    addon_services: `${base}${sub_url}addon_services`,
    apply_coupon: `${base}${sub_url}addon_services/coupon/apply/`,
    orders: `${base}${sub_url}product/orders`,
    orders_update: `${base}${sub_url}seo/orders/update`,

    CREATE: `${base}${sub_url}/create`,
    GET: `${base}${sub_url}/get`,
    UPDATE: `${base}${sub_url}/edit`,
    DELETE: `${base}${sub_url}/delete`,

}